// extracted by mini-css-extract-plugin
module.exports = {"btn":"ButtonBack_btn__1lolH","secondary":"ButtonBack_secondary__1CifG","img":"ButtonBack_img__4FEpv"};